import { Injectable } from 'angular2/core';

export enum MessageType {
  Default, Primary, Success, Warning, Danger, Info
};

export interface AlertMessage {
  type: MessageType;
  text: string;
}

@Injectable()
export class AlertService {
  messages: AlertMessage[] = [];

  push(message: AlertMessage) {
    this.messages = [...this.messages, message];
  }

  dimiss(index: number, message: AlertMessage) {
    this.messages = [
      ...this.messages.slice(0, index), ...this.messages.slice(index + 1)
    ];
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/alert/alert.service.ts
 **/